import AppDispatcher from "../Dispatcher";
import EventEmitter from "events";
import { AppActionConstants } from "../Actions/AppActionConstants";

class TraffickingDataStore extends EventEmitter {
	constructor() {
		super();

		this.traffickingData = {
			campaigns: [],
			placements: [],
			placementConfig: [],
			selectedCampaign: null,
			placementAuditLevelID: null,
			errors: [],
			filteredData: [],
			recipients: [],
			trafficRequestErrors: {},
			requestDirectionErrors: {},
			addiblePlacements: [],
			landingPages: [],
			jiraTicketExists: null,
			addPlacementsErrors: {},
			mappingErrors: {},
			verifyWithGcmErrors: [],
			redirectID: null
		};

		/*
        Need to register all actions with the AppDispatcher
        */

		AppDispatcher.register((action) => {
			switch (action.type) {
				case AppActionConstants.getTraffickingCampaigns:
					const formattedData = action.value;
					formattedData.forEach((data) => {
						if (data.TrafficRequestDueDate) {
							data.FormattedDueDate = new Date(data.TrafficRequestDueDate).toLocaleDateString("en-US");
						}
						if (data.CampaignStartDate) {
							data.FormattedStartDate = new Date(data.CampaignStartDate).toLocaleDateString("en-US");
						}
						if (data.CampaignEndDate) {
							data.FormattedEndDate = new Date(data.CampaignEndDate).toLocaleDateString("en-US");
						}
						if (data.TrafficLiveDate) {
							data.FormattedLiveDate = new Date(data.TrafficLiveDate).toLocaleDateString("en-US");
						}
					});
					this.traffickingData.campaigns = formattedData;
					this.emit("trafficking_fetched");
					break;
				case AppActionConstants.getTraffickingPlacements:
					this.traffickingData.placements = this.updateExistingValues(action.value, action.value.config);
					this.traffickingData.placementConfig = action.value.config;
					break;
				case AppActionConstants.fetchAuditLevels:
					this.traffickingData.selectedCampaign = action.campaign;
					this.traffickingData.placementAuditLevelID = action.value;
					break;
				case AppActionConstants.resubmitTraffickingSuccess:
					this.emit("resubmit_success");
					break;
				case AppActionConstants.resubmitTraffickingFail:
					this.emit("resubmit_fail");
					break;
				case AppActionConstants.approveTraffickingSuccess:
					this.emit("approve_trafficking_success");
					break;
				case AppActionConstants.approveTraffickingFail:
					this.traffickingData.requestDirectionErrors = action.value;
					this.emit("approve_trafficking_fail");
					break;
				case AppActionConstants.rejectTraffickingSuccess:
					this.emit("reject_trafficking_success");
					break;
				case AppActionConstants.rejectTraffickingFail:
					this.emit("reject_trafficking_fail");
					break;
				case AppActionConstants.submitTraffickingRequestSuccess:
					this.emit("submit_trafficking_success");
					break;
				case AppActionConstants.submitTraffickingRequestRedirect:
					this.traffickingData.redirectID = action.value.TraffickingRequestID;
					this.emit("submit_trafficking_redirect");
					break;
				case AppActionConstants.submitTraffickingRequestFail:
					this.traffickingData.trafficRequestErrors = action.value;
					this.emit("submit_trafficking_fail");
					break;
				case AppActionConstants.editTraffickingSuccess:
					this.emit("edit_trafficking_success");
					break;
				case AppActionConstants.editTraffickingFail:
					this.traffickingData.trafficRequestErrors = action.value;
					this.emit("edit_trafficking_fail");
					break;
				case AppActionConstants.getRecipientsSuccess:
					const formattedRecipients = action.value.map((recipient) => {
						recipient.label = recipient.FullName;
						recipient.value = recipient.UserID;
						return recipient;
					});
					this.traffickingData.recipients = formattedRecipients;
					break;
				case AppActionConstants.mappingSuccess:
					this.emit("mapping_success");
					break;
				case AppActionConstants.mappingFail:
					this.traffickingData.mappingErrors = action.value;
					this.emit("mapping_fail");
					break;
				case AppActionConstants.getPlacementsToAddSuccess:
					this.traffickingData.addiblePlacements = action.value;
					this.emit("addiblePlacements_fetched");
					break;
				case AppActionConstants.addPlacementsSuccess:
					this.emit("add_placements_success");
					break;
				case AppActionConstants.addPlacementsFail:
					this.traffickingData.addPlacementsErrors = action.value;
					this.emit("add_placements_fail");
					break;
				case AppActionConstants.removePlacementsSuccess:
					this.emit("remove_placements_success");
					break;
				case AppActionConstants.removePlacementsFail:
					this.emit("remove_placements_fail");
					break;
				case AppActionConstants.getLandingPages:
					this.traffickingData.landingPages = action.value;
					this.emit("get_landing_pages_success");
					break;
				case AppActionConstants.getPlacementAssignments:
					this.traffickingData.placementAssignments = action.value;
					this.emit("get_placement_assignments_success");
					break;
				case AppActionConstants.insertUpdatePlacementSuccess:
					this.emit("insert_update_placement_assignment_success");
					break;
				case AppActionConstants.insertUpdatePlacementFail:
					this.traffickingData.insertUpdatePlacementErrors = action.value;
					this.emit("insert_update_placement_assignment_fail");
					break;
				case AppActionConstants.getJiraTicketExists:
					this.traffickingData.jiraTicketExists = action.value;
					this.emit("get_jira_ticket");
					break;
				case AppActionConstants.getJiraTicketExistFail:
					this.traffickingData.jiraTicketExists = false;
					this.emit("get_jira_ticket");
					break;
				default:
					break;
			}
		});
	}

	/*
    Getter function to return the current state
    */
	setSelectedCampaign = (campaign) => {
		this.traffickingData.selectedCampaign = campaign;
	};

	getData = () => this.traffickingData.placements;
	getTraffickingRequestCampaigns = () => this.traffickingData.campaigns;
	getPlacementsConfig = () => this.traffickingData.placementConfig;
	getSelectedCampaign = () => this.traffickingData.selectedCampaign;
	getPlacementAuditLevelID = () => this.traffickingData.placementAuditLevelID;
	getRecipients = () => this.traffickingData.recipients;
	getTrafficRequestErrors = () => this.traffickingData.trafficRequestErrors;
	getRequestDirectionErrors = () => this.traffickingData.requestDirectionErrors;
	getLandingPages = () => this.traffickingData.landingPages;
	getPlacementAssignments = () => this.traffickingData.placementAssignments;
	getJiraTicketExists = () => this.traffickingData.jiraTicketExists;
	getAddPlacementErrors = () => this.traffickingData.addPlacementsErrors;
	getInsertUpdatePlacementErrors = () => this.traffickingData.insertUpdatePlacementErrors;
	getMappingErrors = () => this.traffickingData.mappingErrors;
	getRedirectID = () => this.traffickingData.redirectID;
	resetTrafficRequestErrors = () => {
		this.traffickingData.trafficRequestErrors = {};
		this.emit("trafficking_request_errors_reset");
	};

	resetMappingErrors = () => {
		this.traffickingData.mappingErrors = [];
	};

	getAddiblePlacements = () => this.traffickingData.addiblePlacements;
	resetAddiblePlacements = () => {
		this.traffickingData.addiblePlacements = [];
	};

	returnDataRow = (row) => {
		return this.traffickingData.placements[row];
	};

	returnFilteredDataRow = (row) => {
		return this.traffickingData.filteredData[row];
	};

	updatePlacementsDataManually = (placementsData, bundle) => {
		for (const key in bundle) {
			if (bundle[key].Result === true) {
				const newRow = this.returnDataRow(key); // i.e 6 || Not the JKND35 Code
				if (newRow) {
					newRow.PlacementName = bundle[`${key}`].Object.PlacementName;
					newRow.UniqueID = bundle[`${key}`].Object.UniqueID;
					newRow.ParentUniqueIdCode = bundle[`${key}`].Object.ParentUniqueIdCode;
					newRow.ParentDescription = bundle[`${key}`].Object.ParentDescription;
					newRow.PlacementID = bundle[`${key}`].Object.PlacementID;
					newRow.ExternalSystemStatusID = bundle[`${key}`].Object.ExternalSystemStatusID;
					newRow.ExternalSystemResponse = bundle[`${key}`].Object.ExternalSystemResponse;
				} else {
					const existingRow = placementsData.filter((lineItem) => lineItem.UniqueID === key);
					if (existingRow[0]) {
						existingRow[0].UniqueID = bundle[`${key}`].Object.UniqueID;
						existingRow[0].PlacementName = bundle[`${key}`].Object.PlacementName;
					}
				}
			}
		}
	};

	updateExistingValues = (data, config) => {
		const newData = data;
		const fieldNames = {};
		const fieldIds = {};
		const excludedFieldNames = [
			"CampaignID",
			"PlacementName_Friendly",
			"ParentDescription",
			"UniqueID",
			"TaxonomyData",
			"MetaData",
			"PlacementName",
			"PlacementID",
			"PackageType",
			"ExternalSystemResponse",
			"ExternalSystemResponse_Orig",
			"ExternalSystemStatusID",
			"IsArchived",
			"IsDeleted",
			"UpdatedBy"
		];
		config.TaxonomyData.forEach((taxonomyField) => {
			fieldNames[taxonomyField.Name] = taxonomyField.ID;
			fieldIds[taxonomyField.ID] = taxonomyField.Name;
		});
		config.MetaData.forEach((metadataField) => {
			fieldNames[metadataField.Name] = metadataField.ID;
			fieldIds[metadataField.ID] = metadataField.Name;
		});
		config.PlacementData.forEach((placementField) => {
			fieldNames[placementField.Name] = placementField.ID;
			fieldIds[placementField.ID] = placementField.Name;
		});
		newData.forEach((dataField) => {
			if (!_.isEmpty(dataField)) {
				Object.keys(dataField).forEach((dataKeyName) => {
					if (!excludedFieldNames.includes(dataKeyName) && !Object.keys(fieldNames).includes(dataKeyName)) {
						let matchingId = null;
						if (dataField.TaxonomyData !== "") {
							JSON.parse(dataField.TaxonomyData).forEach((dataTaxonomyField) => {
								if (matchingId !== null) {
									return;
								}
								if (dataTaxonomyField.DataKeyShortDescr.split(" ").join("") === dataKeyName) {
									matchingId = dataTaxonomyField.DataKeyID;
								}
							});
						}
						if (matchingId === null) {
							if (dataField.MetaData !== "") {
								JSON.parse(dataField.MetaData).forEach((dataMetaDataField) => {
									if (matchingId !== null) {
										return;
									}
									if (dataMetaDataField.DataKeyShortDescr.split(" ").join("") === dataKeyName) {
										matchingId = dataMetaDataField.DataKeyID;
									}
								});
							}
						}
						if (matchingId !== null) {
							if (fieldIds[matchingId]) {
								dataField[fieldIds[matchingId]] = dataField[dataKeyName];
							}
						}
					}
					if (dataKeyName === "CreativeAgencyID" && !dataField.CreativeAgencyOwner) {
						if (config.MetaData) {
							config.MetaData.forEach((dataKey) => {
								if (dataKey.Name === "CreativeAgencyOwner") {
									dataKey.Options.forEach((agencyOwner) => {
										if (agencyOwner.OptionID === dataField[dataKeyName]) {
											dataField.CreativeAgencyOwner = agencyOwner.OptionLabel;
										}
									});
								}
							});
						}
					}
				});
			}
		});
		return newData;
	};
}

export default new TraffickingDataStore();
